import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';

import CarouselView from 'react/views/carousel/CarouselView';

class MeasuredCarouselView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: props.width
		};

		this.onResize = this.onResize.bind(this);
	}

	onResize(contentRect) {
		if (contentRect.bounds.width !== this.state.width) {
			this.setState({
				width: contentRect.bounds.width
			});
		}
	}

	render() {
		return (
			<Measure bounds onResize={this.onResize}>
				{ ({measureRef}) => (
					<CarouselView {...this.props} measureRef={measureRef} width={this.state.width} />
				)}
			</Measure>
		);
	}
}

MeasuredCarouselView.defaultProps = {
	width: 0
};

MeasuredCarouselView.propTypes = {
	width: PropTypes.number
};

export default MeasuredCarouselView;



// WEBPACK FOOTER //
// ./src/react/views/carousel/MeasuredCarouselView.jsx